<template>
  <div class="text-edit">
    <h2 class="sub-title">Contenu</h2>
    <p class="info">Veuillez saisir un contenu pour ce bloc de texte</p>
    <b-form-input
      @blur="editText"
      @keyup.exact.enter="editText"
      ref="textInput"
      v-model="element.value"></b-form-input>
      <hr/>
    <h2 class="sub-title">Aperçu</h2>
    <div class="wrapper-list">
      <vue-custom-scrollbar class="scroll-area" :settings="settings">
        <text-element :element="this.element"/>
      </vue-custom-scrollbar>
    </div>
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import textElement from '../display/textElement'
export default {
  components: {
    vueCustomScrollbar,
    textElement
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  watch: {
    data: {
      handler (newValue) {
        this.element = {...newValue}
      },
      deep: true
    }
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      element: null
    }
  },
  beforeMount () {
    this.element = {...this.data}
  },
  methods: {
    editText () {
      this.$refs['textInput'].blur()
      this.$emit('textEdit', this.element.value)
    }
  }
}
</script>

<style lang="scss" scoped>
// #panel-fiche{
  .text-edit{
    margin-top: 20px;
    width: 100%;
    p.info{
      font-style: italic;
      color: rgba(0, 0, 0, 0.5);
      font-size: 13px;
      text-align: left;
    }
    .sub-title{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
    }
  }
// }
.wrapper-list {
  .scroll-area {
    height: 270px;
    margin-right: -15px;
    padding-right: 15px;
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #2b3085 !important;
    width: 6px !important;
    right: 0;
    &:hover {
      background-color: #2b3085;
      width: 6px;
    }
  }
  .ps__rail-y {
    display: block;
    width: 8px;
    border: 1px solid #2b3085;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/editElementText.vue